@if (!dentistSelect) {
<!-- <div>
  <input #autoInput [formControlName]="controlName" type="text" id="input-group-1"
    placeholder="{{'address' | translate}}" [class.invalid]="control?.invalid && control?.touched"
    name="floating_first_name" style="color: #111; font-size: 0.875rem;" (change)="handleChange($event)"
    (blur)="handleBlur($event)" class="input-typography border border-gray-300 block w-full p-3" />
  <span class="custom-floating-label">{{'address' | translate}}</span>
  <div class="input-hints  one-line-hint">
    <div class="text">
      {{'error_address_one' | translate}}
    </div>
  </div>
</div> -->

<div class="modal__input column input-area__inactive" (click)="inputItemClick($event)"
   [class.invalid]="control?.invalid && control?.touched">
    <span class="descBlock font-color-gray">Address</span>
   

    <input  #autoInput id="addressInput"  placeholder="" 
        [formControlName]="controlName" (focus)="toggleNeighbourMessageFocus($event)" (focusout)="toggleNeighbourMessageFocusOut($event)"
         [formGroup]="formGroup"  (onAddressChange)="autoCompleteOnChange($event)" />





    <div class="modal__input__message" [class.invalid]="control?.invalid && control?.touched"> Please enter your full street address.
    </div>
    </div>


}
@else {
<div>



  <!-- <input #autoInput [formControlName]="controlName" id="location" placeholder="{{'dentist_location' | translate}}"
    (change)="handleAddressChange($event)" (input)="enterLocation($event)"
    class="input-typography border border-gray-300 block w-full p-3" />
  <span class="custom-floating-label">{{'dentist_location' | translate}}</span> -->



  <div  #autoInput  id="modal__input_location" 
  [class.invalid]="control?.invalid && control?.touched"
     class="modal__input modal__input_location column input-area__inactive"
       (click)="inputItemClick($event)">
              <span class="descBlock font-color-gray">Location</span>
              <input #autoInput required 
           
               id="location" placeholder="" (input)="enterLocation($event)" 
               [formControlName]="controlName"
               (onAddressChange)="autoCompleteOnChange($event)" />
            </div> 



</div>
}